import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ContentCategoriesLevel1Filter = ({
    loading = false,
    hidden = false,
    options = [],
    filters = {},
    restoreFilterValues,
    onChangeValue = () => {},
}) => (
    <Field
        component={Form.ReduxSelect}
        name='contentCategoriesLevel1'
        hidden={hidden}
        options={options}
        disabled={loading}
        placeholder='1st level category'
        loading={loading}
        multiple
        selection
        search
        setValue={restoreFilterValues(filters, 'contentCategoriesLevel1')}
        onChangeValue={onChangeValue}
    />
);

ContentCategoriesLevel1Filter.propTypes = {
    loading: PropTypes.bool,
    hidden: PropTypes.bool,
    options: PropTypes.array,
    filters: PropTypes.object,
    restoreFilterValues: PropTypes.func,
    onChangeValue: PropTypes.func,
};
